type Cancelable = {
  abort?: () => void;
  close?: () => void;
};

export const cleanupEventSources = (sources: Array<Cancelable | null>) => {
  sources.forEach((source) => {
    if (!source) return;

    if (typeof source.abort === 'function') {
      source.abort();
      return;
    }

    if (typeof source.close === 'function') {
      source.close();
    }
  });
};
